/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import {
  py, px, p
} from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';

import { fontButtonLinkHighlighted } from '@styles/typography';
import theme from '@theme';

const { colors, shadows, borderRadius } = theme;

export const buttonLight = css`
  outline: none;
  ${theme.borderRadius.default}
  ${py(3)}
  ${px(3.5)}
  font-size: 1rem;
  color: ${colors.aquaMarine};
  cursor: pointer;
  border: 1px solid ${colors.aquaMarine};
  display: flex;
  align-items: center;
  font-weight: 600;
  ${({ disabled }) => (disabled ? 'opacity: 0.3;' : '')}

  svg,
  path {
    fill: ${colors.aquaMarine};
    stroke: non;
  }
`;

export const button = css`
  ${buttonLight}
  ${shadows.default}
  color: ${colors.white};
  background-color: ${colors.aquaMarine};
  border: none;
`;

export const styledButton = css`
  ${borderRadius.small}
  ${p(3)}
  display: block;
  font-size: 16px;
  text-align: center;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  width: ${({ full }) => (full ? '100%' : 'auto')};
  &:focus {
    outline: none;
  }
`;

export const StyledButton = styled.button`
  ${styledButton}
  ${fontButtonLinkHighlighted}
  ${theme.shadows.medium}
  background-color:#5FA6BF;
  border: none;
`;

export const StyledWhatsappButton = styled.a`
  ${styledButton}
  display: flex;
  align-content: space-between;
  justify-content: center;
  ${fontButtonLinkHighlighted}
  ${theme.shadows.medium}
  background-color: #21CEB5;
  border: none;
  width: ${({ finderForm }) => (finderForm ? 'auto' : '100%')};
`;

export const StyledWhatsappButtonNew = styled.a`
  ${styledButton}
  display: flex;
  ${p(2)}
  align-items: center;
  align-content: center;
  justify-content: center;
  ${fontButtonLinkHighlighted}
  border: none;
  > svg {
    margin: 0px;
    width: 100%;
    height: 100%;
  }
  height: ${props => (props.isModal ? '30px' : '60px')};
  width:60px;
`;

export const StyledButtonTransparentWhite = styled.button`
  ${styledButton}
  ${fontButtonLinkHighlighted}
  box-sizing: border-box;
  width: 140px;
  height: 47px;
  left: 157px;
  top: 230px;
  background: ${props => (props.curefyNavbar ? 'rgb(22 88 69)' : '#4b7f97')};
  border: 2px solid #3d84a3;
  border-radius: 35px;
  border: 1px solid ${colors.translucentWhite50};
  ${breakpoint('mobile', 'desktop')`
  @media only screen and (max-width: 340px) {
  width: 118px;
  height: 43px;
  align-items: center;
   
  }
  `}
`;
